import { render, staticRenderFns } from "./PromotionRemarks.vue?vue&type=template&id=ea483f2a&scoped=true&"
import script from "./PromotionRemarks.vue?vue&type=script&lang=js&"
export * from "./PromotionRemarks.vue?vue&type=script&lang=js&"
import style0 from "./PromotionRemarks.vue?vue&type=style&index=0&id=ea483f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea483f2a",
  null
  
)

export default component.exports